"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * The tooltip on links to restricted GS1 Complete content/downloads
 *
 * @namespace
 * @memberOf txGs1Base.complete
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.complete.tooltip = {
    /**
     * Once append the tooltip to DOM
     *
     * @memberOf txGs1Base.complete.tooltip
     * @public
     */
    insertToDom: function () {
        var tooltip = $('<div></div>')
            .prop('class', 'tooltip-complete-content')
            .appendTo(document.body);
        var completeInfo = $('<p></p>')
            .addClass('complete-info')
            .text('Diese Inhalte sind für GS1 Complete Kunden ' +
            'frei zugänglich, bitte loggen Sie sich ein.')
            .appendTo(tooltip);
        var purchaseInfo = $('<p></p>')
            .addClass('purchase-info')
            .text('Diese Inhalte können Sie auch einzeln kaufen.')
            .appendTo(tooltip);
    },
    /**
     *
     * @memberOf txGs1Base.complete
     * @public
     */
    initialize: function () {
        _main_1.txGs1Base.complete.tooltip.insertToDom();
        $('.complete-link-wrap').tooltipster({
            content: $('.tooltip-complete-content'),
            theme: 'tooltip-complete',
            offsetY: -10,
            touchDevices: false
        });
    }
};
exports.default = {};
